class WelcomeToast extends HTMLElement {
  constructor() {
    super();
    this.handleClose = this.handleClose.bind(this);
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.closeButton = this.querySelector("[data-toast-close]");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleClose);
    }

    this.isDesignMode = typeof Shopify !== "undefined" && Shopify.designMode;
    const isVisible = this.dataset.initialVisible === "true";
    const showInDesignMode = this.dataset.showInDesignMode === "true";
    this.autoHideDelayMs = this.parseAutoHideDelay(this.dataset.autoHideDelay);
    this.autoHideTimeoutId = null;
    this.storageKey = this.dataset.storageKey || null;

    this.hidden = true;

    if (!this.isDesignMode && this.isStoredHidden()) {
      return;
    }

    if (this.isDesignMode && showInDesignMode) {
      this.showToast(true);
      return;
    }

    if (isVisible) {
      window.setTimeout(() => this.showToast(false), 120);
    }
  }

  disconnectedCallback() {
    this.clearAutoHideTimer();
    if (this.closeButton) {
      this.closeButton.removeEventListener("click", this.handleClose);
    }
  }

  showToast(isDesignPreview) {
    window.requestAnimationFrame(() => {
      this.hidden = false;
      if (isDesignPreview) {
        this.classList.add("welcome-toast--design");
      }
      this.classList.add("welcome-toast--visible");

      if (!isDesignPreview && this.autoHideDelayMs > 0) {
        this.scheduleAutoHide();
      }
    });
  }

  handleClose() {
    this.clearAutoHideTimer();
    this.classList.remove("welcome-toast--visible");
    window.setTimeout(() => {
      this.hidden = true;
    }, 220);

    if (!this.isDesignMode) {
      this.persistHiddenState();
    }
  }

  scheduleAutoHide() {
    this.clearAutoHideTimer();
    this.autoHideTimeoutId = window.setTimeout(() => {
      this.handleClose();
    }, this.autoHideDelayMs);
  }

  clearAutoHideTimer() {
    if (this.autoHideTimeoutId) {
      window.clearTimeout(this.autoHideTimeoutId);
      this.autoHideTimeoutId = null;
    }
  }

  parseAutoHideDelay(value) {
    const parsed = parseInt(value, 10);
    if (Number.isNaN(parsed) || parsed < 0) {
      return 5000;
    }

    return parsed * 1000;
  }

  persistHiddenState() {
    if (!this.storageKey) return;

    try {
      window.localStorage?.setItem(this.storageKey, "hidden");
    } catch (error) {
      // ignore storage failures
    }

    if (typeof setCookie === "function") {
      try {
        setCookie(this.storageKey, "hidden", 365);
      } catch (error) {
        // ignore cookie failures
      }
    }
  }

  isStoredHidden() {
    if (!this.storageKey) return false;

    try {
      if (window.localStorage?.getItem(this.storageKey) === "hidden") {
        return true;
      }
    } catch (error) {
      // ignore storage failures and fall back to cookie
    }

    if (typeof getCookie === "function") {
      try {
        return getCookie(this.storageKey) === "hidden";
      } catch (error) {
        return false;
      }
    }

    return false;
  }
}

if (!customElements.get("welcome-toast")) {
  customElements.define("welcome-toast", WelcomeToast);
}
